/** Alt sayfa bloklarının ortak sınıfları. */

export const sectionTitle =
  'm-0 font-display text-[28px] font-semibold leading-[1.12] tracking-[-0.03em] text-white sm:text-[36px]';

export const primaryButton =
  'zh-btn inline-flex min-h-[52px] items-center justify-center gap-2 rounded-[14px] bg-[linear-gradient(135deg,#2563eb,#3b82f6)] px-6 text-[16px] font-bold text-white no-underline shadow-[0_12px_30px_-10px_rgba(59,130,246,0.7)]';

export const secondaryButton =
  'inline-flex min-h-[52px] items-center justify-center gap-2 rounded-[14px] border border-[rgba(120,150,210,0.32)] bg-white/[0.03] px-[22px] text-[16px] font-bold text-white no-underline transition-colors hover:border-blue-400';
